var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTableReload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.375 4.375C4.321 3.12 5.809 2.3 7.5 2.3c2.867 0 5.2 2.333 5.2 5.2a5.21 5.21 0 0 1-4.742 5.18.5.5 0 0 0-.458.497v.302c0 .292.25.523.542.499a6.5 6.5 0 1 0-5.61-10.546L1.355 2.355C1.159 2.159 1 2.215 1 2.49v3.02c0 .27.215.49.49.49h3.02c.27 0 .338-.152.135-.355z"
})));
export default SvgIconTableReload;